import { actionTypes } from "./AllNewsActions";
import { SortTypes } from "../../../util/table-view/TableTypes";
import { defaultPopupResults, pagingTotalRelation, defaultPopupResultsMax } from "../../../redux/Types";

const initialState = {
  posting: { busy: false, message: "", errors: null },
  items: [],
  latestItems: [],
  totalItems: 0,
  latestTotalItems: 0,
  totalRelation: pagingTotalRelation.EQUALS,
  selectedItem: {},
  selectedItems: [],
  loading: false,
  latestLoading: false,
  query: {
    inPage: "all",
    order: SortTypes.desc,
    orderBy: "createdAt",
    page: 0,
    size: defaultPopupResults,
    q: "",
    filters: [],
  },
  queryLatest: {
    inPage: "all",
    order: SortTypes.desc,
    orderBy: "startDate",
    page: 0,
    size: defaultPopupResultsMax,
    q: "",
    filters: [],
  },
  errors: null,
  selectedPreviewItems: [],
  singleView: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.LOADING:
      return {
        ...state,
        loading: true,
        errors: null,
        selectedItems: [],
        items: [],
      };
      
    case actionTypes.LATEST_LOADING:
      return {
        ...state,
        latestLoading: true,
        latestItems: [],
      };

    case actionTypes.LOAD:
      return {
        ...state,
        loading: false,
        errors: null,
        items: action.payload,
        totalItems: action.total,
        totalRelation: action.totalRelation,
        selectedItem: action.payload[0] || {},
        selectedItems: [],
      };

    case actionTypes.LATEST_LOAD:
      return {
        ...state,
        latestLoading: false,
        latestItems: action.payload, 
        latestTotalItems: action.total,
        selectedPreviewItem: [],
      };

    case actionTypes.ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload,
        items: [],
        totalItems: 0,
        totalRelation: pagingTotalRelation.EQUALS,
      };

    case actionTypes.QUERY:
      return {
        ...state,
        query: action.payload,
      };

    case actionTypes.FOCUS_ITEM:
      return {
        ...state,
        selectedItem: action.payload,
      };

    case actionTypes.SELECT_ITEMS:
      return {
        ...state,
        selectedItems: action.payload,
      };

      case actionTypes.SELECT_PREVIEW_ITEM_LOADING:
        return {
          ...state,
          latestLoading: true,
          selectedPreviewItems: [],
          singleView: false,
        };

    case actionTypes.SELECT_PREVIEW_ITEM:
      return {
        ...state,
        latestLoading: false,
        selectedPreviewItems: action.payload,
        singleView: action.singleView || false,
      };

    default:
      return state;
  }
}
